import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { useForm } from 'react-hook-form';
import cx from 'classnames';
import ErrorMessage from './ErrorMessage';
import SubscriptionsCheckbox from './SubscriptionsCheckbox';
import Input from './Input';
import PasswordInput from './PasswordInput';
import Select from './Select';
import countries from 'config/countries';
import { v4 as uuid } from 'uuid';

const FormComponent = ({
    inputs,
    data,
    type,
    errorFields,
    formHeader,
    formFooter,
    formMiddle,
    formContent,
    formMessage,
    submitTitle,
    inline,
    submitHidden,
    className,
    handleSubmitEv,
    handleInputEv,
    whiteBg,
}) => {
    const [isFocus, setFocus] = useState(false);

    const onSubmit = (data) => {
        handleSubmitEv && handleSubmitEv(data);
    };

    const handleChange = (ev) => {
        const { name, value } = ev.target;

        handleInputEv &&
            type === 'register' &&
            handleInputEv({
                name,
                value,
            });
    };

    const handleBlur = () => setFocus(null);
    const handleFocus = (name) => setFocus(name);
    const handeCheckbox = (e) => {
        const { name, checked } = e.target;
        handleSubmitEv &&
            handleSubmitEv({
                name,
                checked,
            });
    };

    const { errors, handleSubmit, control, watch, trigger, setError, formState } = useForm({
        // mode: 'blur'
    });

    const { isSubmitting } = formState;

    const formClasses = cx(
        {
            'form-outline': !className,
        },
        {
            [className]: className && !inline,
        },
        {
            'sign__form--white': whiteBg,
        },
    );

    useEffect(() => {
        if (errorFields) {
            Object.entries(errorFields).map((item) => {
                const [name, message] = item;
                return setError(name, {
                    type: 'server',
                    message,
                });
            });
        }
    }, [errorFields, setError]);

    return (
        <Form onSubmit={handleSubmit(onSubmit)} inline={inline} className={formClasses}>
            {formHeader}
            {formContent && <div className="form__content" dangerouslySetInnerHTML={{ __html: formContent }}></div>}
            {formMessage}

            {inputs.map((item, key) => {
                const inputClasses = cx(
                    {
                        [`a-book__form-control--${item.size}`]: item.size,
                    },
                    {
                        'a-book__form-control': item.size,
                    },
                    {
                        'a-book__form-control--border': item.size,
                    },
                    {
                        'is-invalid': errors[item.name],
                    },
                    {
                        'is-focus': isFocus === item.name,
                    },
                );

                const wrapperClassess = cx('input__wrapper', {
                    [`input__wrapper--${item.size}`]: item.size,
                });

                const inputProps = {
                    item,
                    errors,
                    data,
                    control,
                    watch,
                    trigger,
                    handleBlur,
                    handleFocus,
                    handeCheckbox,
                    handleChange,
                };

                return (
                    <div className={wrapperClassess} key={key}>
                        <Form.Group key={key} controlId={!type === 'subscription' ? `${uuid()}-${type}-${item.name}` : null} className={inputClasses}>
                            {!type === 'subscription' &&
                                item.label &&
                                // && !inline
                                item.name !== 'country' && <Form.Label>{item.label}</Form.Label>}

                            {type === 'subscription' ? (
                                <SubscriptionsCheckbox {...inputProps} />
                            ) : type === 'password' || item.type === 'password' ? (
                                <PasswordInput {...inputProps} />
                            ) : item.name === 'country' ? (
                                <Select {...inputProps} options={countries} />
                            ) : (
                                            <Input {...inputProps} />
                                        )}
                            {item.label &&
                                // && inline
                                item.name !== 'country' && <Form.Label>{item.label}</Form.Label>}

                            {!type === 'subscription' && item.textHelper && (
                                <Form.Text className="text-muted">{item.textHelper}</Form.Text>
                            )}
                        </Form.Group>
                        {errors[item.name] && <ErrorMessage message={errors[item.name].message || 'Required'} />}
                    </div>
                );
            })}
            {formMiddle}
            {!submitHidden && (
                <div className="form-group-submit">
                    <Button variant="primary" type="submit" className="btn__default--filled" disabled={isSubmitting}>
                        {isSubmitting ? 'Wysyłanie' : submitTitle ? submitTitle : 'Zapisz zmiany'}
                    </Button>
                </div>
            )}
            {formFooter}
        </Form>
    );
};

FormComponent.propTypes = {
    inputs: PropTypes.array,
    data: PropTypes.any,
    type: PropTypes.string,
    title: PropTypes.string,
    submitTitle: PropTypes.string,
    inline: PropTypes.bool,
    className: PropTypes.string,
};

export default FormComponent;
